import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import plugin from './plugins/index'
import Empty from './components/Empty'
import './plugins/element.js'
import './plugins/vant.js'
import './plugins/dataV.js'
import './plugins/echarts.js'
import './assets/font/iconfont.css'
import './assets/css/mobile.css'
import './assets/css/reset.css'

Vue.component('empty',Empty)
Vue.use(plugin)
Vue.config.productionTip = false

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
